import { useQuery } from '@tanstack/react-query'
import { BusinessUnit, getReseller as getResellerService } from '@grupoboticario/barril-del-chavo'

import { QUERY_DATA, queryConfig } from 'src/service'
import { IReseller } from 'src/@interfaces'

interface UseResellerByExternalIdParams {
  externalId: string
  businessUnit: BusinessUnit
}

export const useResellerByExternalId = ({
  externalId,
  businessUnit,
}: UseResellerByExternalIdParams) => {
  const getReseller = () => getResellerService({ resellerId: externalId, businessUnit })

  return useQuery<IReseller | undefined>(
    [QUERY_DATA.RESELLER_BY_EXTERNAL_ID],
    getReseller,
    queryConfig,
  )
}
